module.exports = __webpack_public_path__ + "img/1579668499.9fed4541.jpg";